import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class TextAlignment extends BaseOption {
  static userInterfaceComponent = {
    label: "Content Alignment",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          value: "left",
          label: "Left",
        },
        {
          value: "center",
          label: "Center",
        },
        {
          value: "right",
          label: "Right",
        },
      ],
    },
  };

  static defaultValue = "center";
}
